import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { map, Observable } from 'rxjs';
import { Icon, IconModule } from '@y42/core/icon';

@UntilDestroy()
@Component({
  selector: 'y42-empty-state',
  standalone: true,
  imports: [CommonModule, MatButtonModule, IconModule],
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {
  @Input() header?: string;
  @Input() iconName?: Icon;
  @Input() body?: string;

  @Input() @InputObservable() addButtonLabel?: string | TemplateRef<unknown>;
  private readonly addButtonLabel$!: Observable<string | TemplateRef<unknown> | undefined>;

  @Output() add = new EventEmitter<void>();

  readonly state = connectState(this, {
    addButtonLabelTemplate: this.addButtonLabel$.pipe(
      map((label) => (label instanceof TemplateRef ? label : undefined)),
    ),
  });
}
